import React, { useState, useRef } from 'react';
import { ChromePicker } from 'react-color';
import Color from 'color';

import { useClickOutside } from 'hooks/index';

const ColorPicker = ({ name, value, onChange }) => {
  const [isOpened, setOpened] = useState(false);
  const ref = useRef();

  const result = Color(value).isLight() ? Color(value).lightness(40) : Color(value).lightness(20);

  useClickOutside(ref, () => setOpened(false));

  return (
    <div ref={ref} className="flex relative w-full">
      <div
        style={{
          borderColor: result,
        }}
        className="border-2 rounded-full"
      >
        <div
          data-testid="primary-color-btn"
          className="h-10 w-10 rounded-full border-2 border-white cursor-pointer"
          onClick={() => setOpened(!isOpened)}
          style={{
            backgroundColor: result,
          }}
        />
        {isOpened && (
          <div className="absolute mt-3 z-50">
            <ChromePicker
              color={value}
              onChangeComplete={({ rgb }) => {
                onChange({
                  target: {
                    name,
                    value: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`,
                  },
                });
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorPicker;
